import React from 'react';
import Typography from "@mui/material/Typography";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StatusIcon from "../../user/userPage/components/StatusIcon";
import {Box} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Button from "@mui/material/Button";
import {Link} from "react-router";
import {statuses} from "./AdminOrderCard";


function AdminOrderListItem({orderRef, placedOrderRef}) {
    return (
        <div className="adminorderlistitem">
            <Box sx={{pt: 2}}>
                <Stepper alternativeLabel activeStep={orderRef.status} sx={{padding: 0}}>
                    {statuses.map((label) => (
                        <Step key={label}>
                            <StepLabel slots={{stepIcon: StatusIcon}} slotProps={{labelName: label}}/>
                        </Step>
                    ))}
                </Stepper>
            </Box>
            <Grid container alignItems={"center"}>
                <Grid size={9}>
                    <Typography sx={{pt: 2, px: 10}}>
                        {orderRef.date}
                    </Typography>
                    <Typography sx={{pb: 2, px: 10}}>
                        {orderRef.ref}
                    </Typography>
                </Grid>
                <Grid size={3}>
                    <Link to={`/admin/order/?ref=${encodeURIComponent(orderRef.ref)}&placedOrderRef=${encodeURIComponent(placedOrderRef)}`}>
                    <Button variant={'contained'}>Open</Button>
                    </Link>
                </Grid>
            </Grid>
        </div>
    );
}

export default AdminOrderListItem;
